import { useEffect, useState, useRef } from "react";
import PropTypes from "prop-types";

import { productHelper } from "@lib/helpers";
import ProductListItem from "@components/ProductList/ProductListItem";
import ProductListResealedItem from "@components/ProductList/ProductListResealedItem";

const getProductsPerRow = ({ listType, width }) => {
  if (width < 640) return 2;

  if (listType === "wishlist") {
    return 3;
  }

  if (width < 1021) return 3;

  return 4;
};

const getProductsInCurrentRow = ({ products, index, productsPerRow }) => {
  const currentRowStartIndex =
    Math.floor(index / productsPerRow) * productsPerRow;
  const currentRowEndIndex = currentRowStartIndex + productsPerRow - 1;

  return products.slice(currentRowStartIndex, currentRowEndIndex + 1);
};

const ProductList = ({
  products,
  containerClass,
  filter,
  listType,
  onProductClick,
  deleteFromWishlist,
}) => {
  const observerRef = useRef(null);
  const [width, setWidth] = useState();
  const isResealedSelected = !filter
    ? false
    : Object.keys(filter.filters).includes("resigilate-8691");

  useEffect(() => {
    observerRef.current = new ResizeObserver((entries) => {
      setWidth(entries[0].contentRect.width);
    });

    observerRef.current.observe(document.querySelector("body"));

    return () => {
      observerRef.current.disconnect();
    };
  }, []);

  return (
    <ul className={`${containerClass} -mx-1 sm:-mx-2`}>
      {products.map((product, i) => {
        const { isSaleable } = productHelper(product);

        const productsPerRow = getProductsPerRow({ listType, width });

        const productsInCurrentRow = getProductsInCurrentRow({
          products,
          index: i,
          productsPerRow,
        });

        const hasColorVariationsInCurrentRow = productsInCurrentRow.some(
          (p) =>
            p.configurable_options?.length &&
            p.configurable_options.find(
              (option) => option.attribute_code === "culoare_global"
            )
        );

        const isStockZeroWithResealed =
          !isSaleable &&
          product.resealed_count > 0 &&
          product.pickup_is_in_stock < 1;

        if (isResealedSelected || isStockZeroWithResealed) {
          return (
            <ProductListResealedItem
              key={product.id + "-" + i}
              listType={listType}
              product={product}
              deleteFromWishlist={deleteFromWishlist}
              onProductClick={onProductClick}
              hasColorVariationsInCurrentRow={hasColorVariationsInCurrentRow}
            />
          );
        } else {
          return (
            <ProductListItem
              key={product.id + "-" + i}
              index={i}
              listType={listType}
              product={product}
              onProductClick={onProductClick}
              deleteFromWishlist={deleteFromWishlist}
              hasColorVariationsInCurrentRow={hasColorVariationsInCurrentRow}
            />
          );
        }
      })}
    </ul>
  );
};

ProductList.propTypes = {
  onProductClick: PropTypes.func.isRequired,
};

export default ProductList;
